<template>
    <div class="my-index" :style="padding">
        <div class="my-top"
             :style="{backgroundImage: 'url(' +adImgUrl+  ')', backgroundSize:'100% 100%', backgroundRepeat: 'no-repeat'}"
             v-if="member&&member.id">
            <div style="width: 18%;">
                <img v-if="member&&member.headPortrait" :src="member.headPortrait" class="my-tou"/>
                <div v-else>
                    <img v-if="member.sex==0" src="./../../assets/nan.png" class="my-tou"/>
                    <img v-if="member.sex==1" src="./../../assets/nan.png" class="my-tou"/>
                    <img v-if="member.sex==2" src="./../../assets/nv.png" class="my-tou"/>
                </div>
            </div>
            <div class="my-mbinfo">
                <span style="font-size: 13px;height: 20px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{member.memberName}}</span>
                <span style="font-size: 11px;margin-bottom: 3px">{{member.jmPhone}}</span>
                <div class="my-mbgn">
                    <span style="font-size: 10px;background-color: gainsboro;padding: 3px 10px"
                          @click="toPoster">推广码</span>
                    <span style="font-size: 10px;background-color: gainsboro;padding: 3px 10px;margin-left: 8px">{{member.pmName==null?'PLUS: 未开通':member.pmName}}</span>
                </div>
            </div>
        </div>
        <div class="my-top"
             :style="{backgroundImage: 'url(' +adImgUrl+  ')', backgroundSize:'100% 100%', backgroundRepeat: 'no-repeat'}"
             v-else>
            <div style="width: 18%;">
                <img src="./../../assets/touxiang.png" class="my-tou"/>
            </div>
            <div class="my-mbinfo">
                <span style="font-size: 13px;" @click="login">登录</span>
            </div>
        </div>
     <div style="margin-top: -55px">
         <div class="mys" v-for="item in mys" v-if="mys.length>0">
             <template>
                 <div>
                     <component :is="item.htmlContent" :item="item" :kfUrl="kfUrl"></component>
                 </div>
             </template>
         </div>
     </div>

        <van-popup v-model="showPoster">
            <div id="imageWrapper1">
                <div class="content_container">
                    <vue-canvas-poster v-if="!posterImg" :widthPixels="595" :heightPixels="842" :painting="painting"
                                       @success="success" @fail="fail">
                    </vue-canvas-poster>
                    <van-image :src="posterImg" id="mypic" class="hb-img" crossOrigin="anonymous"/>
                </div>
            </div>
            <!--      <div style="background-color:#484848;opacity:1;display: block;">-->
            <!--        <van-button type="danger" style="width: 100%;height: 38px;line-height: 38px" @click="toSaveImage(posterImg)">保存图片</van-button>-->
            <!--      </div>-->
        </van-popup>
    </div>
</template>

<script>
    import {getCookie, getDeptId, getDeptName} from "../../utils/auth";
    import OrderGn from "./orderGn/index";
    import ServiceGn from "./serviceGn/index";
    import MemberGn from "./memberGn/index";
    import Information from "./information/index";
    import TabBp from "./bp/bp";

    export default {
        components: {
            OrderGn,
            ServiceGn,
            MemberGn,
            Information,
            TabBp,
        },
        data() {
            return {
                token: '',
                deptId: '',
                member: {},
                notice: {},
                adImgUrl: '',
                showPoster: false,
                posterImg: '',//生成的海报
                painting: {
                    views: []
                },
                touxiang: '',
                kfUrl: '',
                dept: {},

                mys: '',
                padding: '',
            };
        },
        async created() {
            this.detectAppleDevice();
            document.title = getDeptName()
            this.token = getCookie('spmToken')
            this.deptId = getDeptId()
            this.getMemberInfo()
            this.getSpmGns()
        },

        methods: {
            detectAppleDevice() {
                const userAgent = navigator.userAgent;
                let is = /iPhone|iPad|iPod/.test(userAgent);
                if (is) {
                    this.padding = 'padding-bottom: 80px;'
                } else {
                    this.padding = 'padding-bottom: 45px;'
                }
            },
            login() {
                // this.$router.push('/login/' + this.deptId + '/' + this.dept.deptName)
                if (this.dept.hloginType == 3) {
                    this.$router.push('/login/' + this.deptId + '/' + this.dept.deptName)
                } else {
                    this.$router.push('/empower/' + this.deptId)
                }
            },
            async getSpmGns() {
                let data = {
                    deptId: this.deptId,
                    route: '/my',
                }
                let res = await this.$get("/spm/getSpmGns", data)
                this.mys = res.list
                this.kfUrl = res.kfUrl
            },

            async getMemberInfo() {
                let data = {
                    token: this.token,
                    deptId: this.deptId
                }
                let res = await this.$get("/spm/getMemberInfo", data)
                this.member = res.member
                this.dept = res.dept
                if (res.member && res.member.headPortrait) {
                    this.touxiang = res.member.headPortrait
                }
                if (res.notice && res.notice.adImgUrl) {
                    this.adImgUrl = res.notice.adImgUrl
                }
            },

            // //跳转客服
            // toKF() {
            //     if (this.kfUrl) {
            //         window.location.href = this.kfUrl
            //     }
            // },

            async toPoster() {
                this.showPoster = true
                let data = {
                    token: this.token,
                }
                let res = await this.$get("/spm/getSpmTgPoster", data)
                var pmName = res.pmName == null ? '未开通' : res.pmName
                let touxiang = res.headPortrait
                if (!touxiang) {
                    if (res.sex == 2) {
                        touxiang = require('./../../assets/nv.png')
                    } else {
                        touxiang = require('./../../assets/nan.png')
                    }
                }
                this.painting = {
                    position: 'relative',
                    width: '595px',
                    height: '842px',
                    background: '#FFFFFF',
                    views: [
                        {
                            type: 'image',
                            url: res.qrCode,
                            css: {
                                position: 'absolute',
                                right: '26%',
                                top: '28%',
                                color: '#000',
                                background: '#fff',
                                width: '288px',
                                height: '288px',
                                borderWidth: '40px',
                                borderColor: '#fff',
                            },
                        },
                        {
                            type: "text",
                            text: "- 长按识别查看 -",
                            css: {
                                top: "63%",
                                right: '25%',
                                width: "300px",
                                maxLines: 1,
                                textAlign: "center",
                                fontSize: "32px",
                                color: "#D3D3D3",
                            },
                        },
                        {
                            type: 'image',
                            url: touxiang,
                            css: {
                                position: 'absolute',
                                top: '9%',
                                left: '22%',
                                color: '#000',
                                background: '#fff',
                                width: '80px',
                                height: '80px',
                                borderRadius: '60px',
                            },
                        },
                        {
                            type: "text",
                            text: res.mbName,
                            css: {
                                top: "9%",
                                left: "40%",
                                width: "250px",
                                maxLines: 1,
                                textAlign: "left",
                                fontSize: "32px",
                                color: "#8B8A8A",
                            },
                        },
                        {
                            type: "text",
                            text: "PLUS: " + pmName,
                            css: {
                                top: "15%",
                                left: "41%",
                                height: "30px",
                                padding: "5px",
                                lineHeight: "25px",
                                maxLines: 1,
                                textAlign: "left",
                                fontSize: "20px",
                                color: "#8B8A8A",
                                background: "#eeeeef",
                            },
                        },
                        {
                            type: 'image',
                            url: require('./../../assets/md.png'),
                            css: {
                                position: 'absolute',
                                top: '76%',
                                left: '28.5%',
                                color: '#000',
                                background: '#fff',
                                width: '58px',
                                height: '58px',
                            },
                        },
                        {
                            type: "text",
                            text: res.deptName,
                            css: {
                                top: "76%",
                                left: "38%",
                                width: "200px",
                                height: "30px",
                                lineHeight: "25px",
                                maxLines: 1,
                                textAlign: "center",
                                fontSize: "45px",
                                color: "#8B8A8A",
                            },
                        },
                    ],
                }
            },

            // 保存图片到本地
            toSaveImage(img) {
            },

            // 海报生成
            success(src) {
                this.posterImg = src
            },

            //赋值
            handleUpdateBg(row) {
                this.posterImg = ''
                this.painting.views[0].url = row.qrUrl
            },

            fail() {

            },
        },
    };
</script>

<style lang="scss" scoped>
    .my-index {
        background-color: #F2F2F2;
        height: 100%;
        overflow: auto;
    }
    
    .my-top {
        height: 200px;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0px 32px 50px 32px;
    }

    .my-tou {
        width: 50px;
        height: 50px;
        border-radius: 50px;
    }

    .my-mbinfo {
        display: flex;
        flex-direction: column;
        margin-left: 8px;
        padding-top: 8px;
        width: 60%;
    }

    .my-mbgn {
        display: flex;
        flex-direction: row;
        margin-top: 3px;
    }

    .content_container {
        width: 256px;
        height: 356px;
        overflow: hidden;
        margin: auto;
        background-size: 100% 100%;
    }

    .hb-img {
        width: 256px;
        height: 356px;
        background-size: 100% 100%;
    }

    .mys {
        margin-bottom: 12px;
    }

</style>
